import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Badge } from "@/components/ui/badge";
import { GraduationCap, ArrowRight } from "lucide-react";

interface ExpertBrief {
  id: string;
  name: string;
  title: string;
  quote: string;
  profile_image: string | null;
}

const DozentenDuo = () => {
  const [experts, setExperts] = useState<ExpertBrief[]>([]);

  useEffect(() => {
    const fetch = async () => {
      const { data } = await supabase
        .from("experts")
        .select("id, name, title, quote, profile_image")
        .in("name", ["Ingo Zang", "Patrik Germann"])
        .order("display_order", { ascending: true });
      if (data) setExperts(data);
    };
    fetch();
  }, []);

  if (experts.length === 0) return null;

  return (
    <section className="py-16 bg-muted/50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-10">
          <Badge variant="secondary" className="mb-3 text-xs uppercase tracking-wide">
            <GraduationCap className="w-3 h-3 mr-1" /> Ihre Dozenten
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold mb-2">
            Zertifizierte Expertise: Begleitet von den MAIP-Gründern
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Von der Theorie in die Führungspraxis – Online mit Ingo Zang, vor Ort mit Patrik Germann.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {experts.map((e) => (
            <div
              key={e.id}
              className="flex flex-col items-center text-center bg-background rounded-xl border border-border p-8 shadow-sm hover:shadow-md transition-shadow"
            >
              {e.profile_image ? (
                <img
                  src={e.profile_image}
                  alt={e.name}
                  className="w-24 h-24 rounded-full object-cover border-4 border-primary/20 mb-4"
                  style={e.name === "Ingo Zang" ? { objectPosition: "center top", transform: "scale(1.15)" } : {}}
                />
              ) : (
                <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                  <GraduationCap className="w-10 h-10 text-primary/40" />
                </div>
              )}
              <h3 className="text-lg font-bold">{e.name}</h3>
              <p className="text-sm text-muted-foreground mb-3">{e.title}</p>
              <p className="text-sm italic text-muted-foreground leading-relaxed">„{e.quote}"</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link to="/dozierende-team" className="text-sm font-medium text-primary hover:underline inline-flex items-center gap-1">
            Alle Dozierenden & das Team kennenlernen <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default DozentenDuo;
